'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Col, Icon, Row, Typography } from '@repo/ui/components'

export const HistoryBalanceAllHeaderLayout = () => {
  const { t } = useTranslate()

  return (
    <Col className='gap-xs py-xs'>
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/wallet'
        startIcon={<Icon name='ArrowRightLine' size='md' />}
      >
        {t('common_back')}
      </ButtonLink>
      <Row className='justify-between gap-md'>
        <Typography size='lg' weight='bold'>
          {t('walletPage_all_history')}
        </Typography>
      </Row>
    </Col>
  )
}
